import { render } from "./bulletListComponent.vue?vue&type=template&id=04fbd69d&ts=true"
import script from "./bulletListComponent?vue&type=script&lang=ts"
export * from "./bulletListComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__